import { useEffect } from 'react';

export function RedirectToAuth() {
  useEffect(() => {
    window.location.replace(process.env.REACT_APP_AUTH_APP_BASE_URL);
  }, []);

  return null;
}
